import React from 'react';
import injectSheet from 'react-jss';
import LoginForm  from '../components/LoginForm';
import { CardImg } from 'reactstrap';


const styles = {
  root: {
    background: '#fff',
    boxShadow: '0 0.125rem 0.75rem -0.125rem rgba(0, 0, 0, 0.25)',
    borderRadius: '0.3125rem',
    minWidth: 400,
  },
  formGroup: {
    marginBottom: '1rem',
  },
  cardFooter: {
    background: "none",
    border: "none"
  },
  button: {
    width: "100%", 
    marginBottom: "1rem",
    background: "#34A5DA"
  },
  container: {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f2f3f1"
  },
  imageWrapper: {
    margin: '0 auto',
    width: '15rem',
    marginBottom: '1rem',
  },
  wrapper: {
    height: 'calc(100% - 10rem)',
  },
};

export function Login(props) {
  const { classes } = props;

  return (
    <div className={classes.container}>
      <div className={classes.wrapper}>
        <div className={classes.imageWrapper}><CardImg top width="100%" src={require(`../assets/logo.svg`)} alt="Card image cap" /></div>
        <LoginForm handleLogin={props.handleLogin} />
      </div>
    </div>
  );
}

export default injectSheet(styles)(Login);



// WEBPACK FOOTER //
// ./src/pages/LoginPage.js